/* ================================================================
   LUMA - LET LUMA CHOOSE, AND THE DIAMOND STEP COPY FIXES
   Added 6 October 2026. Companion to luma-diamond-media.js.

   WHY THIS IS A SECOND FILE AND NOT PART OF THAT ONE
   Purely an operational safety call. luma-diamond-media.js was already
   uploaded and checksum verified against the local source. The Admin API can
   only replace a theme file whole, so folding this in would have meant
   retransmitting a verified file to change nothing in it. Two small files that
   each verify cleanly beat one larger file that has to be rewritten every time
   either half changes.

   WHAT IT DOES
   1. Takes GIA out of the certification badge on the diamond step.
   2. Fixes "lab-grown" to "lab grown", which is the brand rule.
   3. Adds the Luma Recommends note, linking to the page that already carries
      the proportions table rather than restating it.
   4. Adds Let Luma Choose, as an enquiry, never as an add to cart.

   WHERE LET LUMA CHOOSE SITS, AND WHY IT IS QUIET
   v1 put it directly under Browse Diamonds as a full width bordered button,
   which read as an equal alternative to browsing. Asher, 6 Oct: "making let
   luma choose not an option as big as browse diamonds. maybe it can come
   later after they've had a look at the diamonds". So it now sits BELOW the
   results, as a plain text link, and stays hidden until a search has actually
   returned stones. Someone who is happy browsing never sees it. Someone who
   has scrolled a list and not found their stone does.

   Keep it that way. The point of the ring builder is that the customer
   chooses. This is the fallback, not the fork in the road.

   THE BUDGET QUESTION IS ABOUT THE RING, NOT THE STONE
   v1 asked for a stone budget. Asher, 6 Oct: "I don't think customers will
   really know what their stone budget is specifically, but more of a budget
   for the overall ring." Correct, and it is the more useful number anyway,
   since we know the setting price and can work backwards.

   WHY INJECTED RATHER THAN PUT IN THE LIQUID
   snippets/luma-product-configurator.liquid is 49KB of markup and SVG path
   data and can only be replaced whole, which is the operation that has lost
   characters in this theme before. Everything here targets the diamond step,
   which is display:none until the customer reaches step 3, so none of it can
   flash before this runs. Verified on the Astrid page, 6 Oct 2026.

   THE GIA FIX IS A STOPGAP. The badge still says GIA in the snippet source.
   Correct it there when convenient and point 1 above can go.

   If anything here throws, the configurator carries on exactly as it does
   today. Nothing below may block a search or an order.
   ================================================================ */
(function () {
  var root = document.getElementById('luma-config');
  if (!root) return;

  var STYLE_ID = 'luma-choose-styles';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function hidden(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = name;
    i.value = value == null ? '' : value;
    return i;
  }

  function field(labelText, id, name, type, placeholder, required) {
    var frag = document.createDocumentFragment();
    var l = el('label', 'luma-choose__label', labelText);
    l.setAttribute('for', id);
    var i;
    if (type === 'textarea') {
      i = document.createElement('textarea');
      i.rows = 3;
      i.className = 'luma-choose__input luma-choose__textarea';
    } else {
      i = document.createElement('input');
      i.type = type;
      i.className = 'luma-choose__input';
    }
    i.id = id;
    i.name = name;
    if (placeholder) i.placeholder = placeholder;
    if (required) i.required = true;
    frag.appendChild(l);
    frag.appendChild(i);
    return frag;
  }

  // Shopify's own contact form needs only form_type and utf8, no token.
  // Confirmed by reading all three live contact forms on /pages/contact,
  // 6 Oct 2026. The theme also stamps contact[Source] into contact forms,
  // so those two values are copied across from whichever form already has
  // them rather than recomputing attribution, which luma-attribution owns.
  function buildChoose() {
    var wrap = el('div', 'luma-choose');
    wrap.id = 'luma-choose';
    wrap.hidden = true;   // revealed by syncVisibility once stones are listed

    wrap.appendChild(el('p', 'luma-choose__lead', 'Not sure which one to pick?'));

    var open = el('button', 'luma-choose__open', 'Let our gemologist choose for you');
    open.type = 'button';
    open.id = 'luma-choose-open';
    open.setAttribute('aria-expanded', 'false');
    open.setAttribute('aria-controls', 'luma-choose-panel');
    wrap.appendChild(open);

    wrap.appendChild(el('p', 'luma-choose__sub',
      'We send you a couple of options to look at, and we buy nothing until you have approved the stone.'));

    var panel = el('div', 'luma-choose__panel');
    panel.id = 'luma-choose-panel';
    panel.hidden = true;

    // Shopify redirects back with contact_posted=true after a successful send.
    if (window.location.search.indexOf('contact_posted=true') > -1) {
      panel.appendChild(el('p', 'luma-choose__ok',
        'Thank you. We have your request and we will come back to you with a couple of options.'));
      panel.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      wrap.hidden = false;
      wrap.appendChild(panel);
      return wrap;
    }

    var form = document.createElement('form');
    form.id = 'luma-choose-form';
    form.className = 'luma-choose__form';
    form.method = 'post';
    form.action = '/contact#luma-choose-form';
    form.setAttribute('accept-charset', 'UTF-8');

    form.appendChild(hidden('form_type', 'contact'));
    form.appendChild(hidden('utf8', '✓'));
    form.appendChild(hidden('contact[Enquiry Type]', 'Let Luma Choose'));

    var titleEl = document.querySelector('.product__title h1, h1.product__title, h1');
    form.appendChild(hidden('contact[Setting]', titleEl ? titleEl.textContent.trim() : ''));

    var m = hidden('contact[Metal]', ''); m.id = 'luma-choose-metal'; form.appendChild(m);
    var s = hidden('contact[Shape]', ''); s.id = 'luma-choose-shape'; form.appendChild(s);
    var c = hidden('contact[Carat]', ''); c.id = 'luma-choose-carat'; form.appendChild(c);

    ['contact[Source]', 'contact[Source detail]'].forEach(function (n) {
      var found = document.querySelector('input[name="' + n + '"]');
      if (found) form.appendChild(hidden(n, found.value));
    });

    form.appendChild(field('Your name', 'luma-choose-name', 'contact[name]', 'text', null, true));
    form.appendChild(field('Email', 'luma-choose-email', 'contact[email]', 'email', null, true));
    form.appendChild(field('Budget for the whole ring', 'luma-choose-budget', 'contact[Ring budget]', 'text', 'A rough figure is fine, setting included', false));
    form.appendChild(field('Anything else we should know', 'luma-choose-notes', 'contact[Notes]', 'textarea', 'Timing, ring size, the style they already wear', false));

    var submit = el('button', 'luma-config__btn luma-config__btn--primary luma-choose__submit', 'Send my request');
    submit.type = 'submit';
    form.appendChild(submit);

    form.appendChild(el('p', 'luma-choose__small',
      'We reply by email. Nothing is ordered and nothing is charged from this form.'));

    panel.appendChild(form);
    wrap.appendChild(panel);
    return wrap;
  }

  function injectMarkup() {
    var panel = root.querySelector('[data-panel="3"]');
    if (!panel || panel.getAttribute('data-luma-injected') === '1') return;

    var results = document.getElementById('luma-diamonds-results');
    if (!results) return;   // nothing to sit under yet
    panel.setAttribute('data-luma-injected', '1');

    var badge = panel.querySelector('.luma-config__lab-badge');
    if (badge && badge.textContent.indexOf('GIA') > -1) {
      badge.textContent = '✦ Lab Grown · IGI Certified';
    }

    // The brand rule is "lab grown", never "lab-grown".
    var sub = panel.querySelector('.luma-config__panel-sub');
    if (sub) {
      sub.textContent = 'Browse certified lab grown diamonds. Set your preferences and hit Browse, then tap any stone to see it larger and turn it in 360.';
    }

    if (badge && !panel.querySelector('.luma-guide-note')) {
      var note = el('p', 'luma-guide-note');
      note.appendChild(el('span', null, 'Stones marked '));
      note.appendChild(el('strong', null, 'Luma Recommends'));
      note.appendChild(el('span', null, ' sit inside the proportion ranges we work to for that shape. Everything listed here is IGI certified and graded Excellent for polish and symmetry. '));
      var a = el('a', null, 'How we choose your diamond');
      a.href = '/pages/how-we-choose-your-diamond';
      note.appendChild(a);
      badge.parentNode.insertBefore(note, badge.nextSibling);
    }

    // BELOW the results, not beside Browse. See the header comment.
    if (!document.getElementById('luma-choose')) {
      results.parentNode.insertBefore(buildChoose(), results.nextSibling);
    }
  }

  // Stays out of the way until the customer has actually seen some stones.
  // Once the form is open it stays open, even if they run another search.
  function syncVisibility() {
    var wrap = document.getElementById('luma-choose');
    var results = document.getElementById('luma-diamonds-results');
    if (!wrap || !results) return;
    var formPanel = document.getElementById('luma-choose-panel');
    if (formPanel && !formPanel.hidden) { wrap.hidden = false; return; }
    wrap.hidden = !results.querySelector('.luma-config__diamond-card');
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '.luma-guide-note { margin: 0 0 18px; font-size: 11px; line-height: 1.6; color: #8a8175; }',
      '.luma-guide-note strong { color: #1C3320; font-weight: 600; }',
      '.luma-guide-note a { color: #1C3320; text-decoration: underline; text-decoration-color: #E8D5A3; text-underline-offset: 3px; white-space: nowrap; }',
      // Quiet by design. Do not give this a border or a full width button.
      '.luma-choose { margin: 16px 0 0; text-align: center; }',
      '.luma-choose[hidden] { display: none !important; }',
      '.luma-choose__lead { margin: 0 0 3px; font-size: 11px; line-height: 1.5; color: #8a8175; }',
      '.luma-choose__open { font-family: inherit; font-size: 11px; line-height: 1.5; padding: 0; border: 0; background: none; color: #1C3320; text-decoration: underline; text-decoration-color: #E8D5A3; text-underline-offset: 3px; cursor: pointer; }',
      '.luma-choose__open:hover { text-decoration-color: #C9A456; }',
      '.luma-choose__open:focus-visible { outline: 2px solid #C9A456; outline-offset: 2px; }',
      '.luma-choose__sub { margin: 4px 0 0; font-size: 10px; line-height: 1.5; color: #8a8175; }',
      '.luma-choose__panel { margin-top: 14px; padding: 16px; background: #F8F6F1; border: 1px solid #ece7dc; border-radius: 4px; text-align: left; }',
      '.luma-choose__panel[hidden] { display: none !important; }',
      '.luma-choose__label { display: block; margin: 0 0 4px; font-size: 10px; letter-spacing: 0.08em; text-transform: uppercase; color: #8a8175; }',
      '.luma-choose__input { width: 100%; box-sizing: border-box; margin: 0 0 12px; padding: 10px 12px; font-family: inherit; font-size: 13px; color: #1a1a1a; background: #fff; border: 1px solid #ece7dc; border-radius: 3px; }',
      '.luma-choose__input:focus { outline: none; border-color: #C9A456; }',
      '.luma-choose__textarea { resize: vertical; min-height: 64px; }',
      '.luma-choose__submit { width: 100%; }',
      '.luma-choose__small { margin: 10px 0 0; font-size: 10px; line-height: 1.5; color: #8a8175; text-align: center; }',
      '.luma-choose__ok { margin: 0; font-size: 13px; line-height: 1.6; color: #1C3320; }'
    ].join('\n');
    var tag = document.createElement('style');
    tag.id = STYLE_ID;
    tag.appendChild(document.createTextNode(css));
    document.head.appendChild(tag);
  }

  function tick() {
    try {
      injectStyles();
      injectMarkup();
      syncVisibility();
    } catch (e) { /* never break the configurator */ }
  }

  var obs = new MutationObserver(tick);
  obs.observe(root, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();
